/**
 * Formatting helpers for weight, height, contact info, etc.
 */

/** Format weight with "kg" suffix when missing. */
export function formatWeight(value) {
    if (value === null || value === undefined || value === '') return '-';
    return `${value} kg`;
}

/** Format height with "cm" suffix when missing. */
export function formatHeight(value) {
    if (value === null || value === undefined || value === '') return '-';
    return `${value} cm`;
}

/** Format a phone number for tel: link. */
export function telLink(value) {
    if (!value) return '#';
    return `tel:${String(value).replace(/\s+/g, '')}`;
}

/** Title-case for gender display. */
export function titleCase(value) {
    if (!value) return '-';
    const s = String(value);
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}